import { Event } from "../../../pojo/Event";
import { Proto } from "../../../pojo/Proto";
import { Task } from "../../../pojo/Task";
import { S25Util } from "../../../util/s25-util";
import { OptUtil } from "../../s25-opt/s25.opt.util";
import NumericalBoolean = Proto.NumericalBoolean;

export interface CalendarData {
    obj_id?: number;
    comptype: OptUtil.CompType;
    events: CalendarData.DayOfEvents[];
    weekday: Proto.DowName[];
    days_per_row: number | string;
    lastupdate: Proto.ISODateString;
    last_id?: number;
}

export namespace CalendarData {
    /**
     * A day on the calendar and all of its events
     */
    export interface DayOfEvents {
        /**
         * day of the month (1-31)
         */
        day: number;
        date: Proto.ISODateString;
        is_start?: NumericalBoolean;
        month_name?: string;
        rsrv?: Reservation[];
        create_event?: NumericalBoolean;
        is_today?: NumericalBoolean;
        hasMore?: number;
    }

    export interface Reservation {
        /**
         * event_id is omitted if it's a blackout
         */
        event_id?: number;
        rsrv_start_dt?: Proto.ISODateString;
        rsrv_end_dt?: Proto.ISODateString;
        addtl_start_dt?: Proto.ISODateString | Date;
        addtl_end_dt?: Proto.ISODateString | Date;
        calendar_date?: Proto.ISODateString;
        profile_name?: string;
        subject: Subject[];
        all_day?: NumericalBoolean;
        has_registration?: NumericalBoolean;
        reg_url?: RegistrationUrl;
        event_name?: string;
        itemId?: number;
        itemName?: string;
        itemTypeId?: number;
        itemId2?: number;
        itemState?: Event.State.Id;
    }
    export namespace Reservation {
        export function classes(item?: Reservation): string {
            return item && S25Util.parseInt(item.itemState) === Event.State.Ids.Cancelled ? "ngStrikethrough" : "";
        }
    }

    export interface RegistrationUrl {
        val: string;
        txt: string;
    }

    export interface Subject {
        itemName: string;
        itemId: number;
        itemId2?: number;
        itemTypeId: number | string;
        itemStateId?: Task.State;
        taskId?: number;
        taskType?: number;
        eventId?: number;
        assignedToId?: number;
        isTodo?: boolean;
        todoType?: number;
        has_more?: NumericalBoolean;
        is_hidden?: NumericalBoolean;
        comment?: string;
    }

    export interface Blackout {
        date: BlackoutDate[];
        profile_name: string;
        room: string;
    }

    export interface BlackoutDate {
        start_dt: Proto.ISODateString;
        end_dt: Proto.ISODateString;
    }
}
